export default "__VITE_ASSET__DIXQLpCe__"